import { ReactNode } from 'react';
import { ConfigProvider, theme } from 'antd';
import { Navigate } from 'react-router-dom';
import useAuthStore from '../stores/authStore';
import AiAssistantWidget from '../components/ai/AiAssistantWidget';
import PayDialogHost from '../components/payment/PayDialogHost';

const darkTheme = {
  algorithm: theme.darkAlgorithm,
  token: {
    colorPrimary: '#1890ff',
    colorBgContainer: '#1a1a2e',
    colorBgElevated: '#1a1a2e',
    colorBgLayout: '#0f0f1a',
    colorBorder: '#333',
    colorText: '#e0e0e0',
    colorTextSecondary: '#888',
    borderRadius: 4,
  },
};

export default function EditorLayout({ children }: { children: ReactNode }) {
  const { isAuthenticated } = useAuthStore();

  if (!isAuthenticated) {
    // 2026-08-26｜修复：未登录重定向必须携带完整目标（含 query），否则登录后 ?preview3d=1 等参数丢失
    const target = window.location.pathname + window.location.search;
    return <Navigate to={`/login?redirect=${encodeURIComponent(target)}`} replace />;
  }

  return (
    <ConfigProvider theme={darkTheme}>
      <div style={{ width: '100vw', height: '100vh', overflow: 'hidden', background: '#1a1a2e' }}>
        {children}
        {/* P2 E-02：编辑器内也可用 AI 帮助助手 */}
        <AiAssistantWidget />
        {/* P3 支付线：全局支付弹窗宿主；弹窗宿主 PopupHost 已提升到 App 级 */}
        <PayDialogHost />
      </div>
    </ConfigProvider>
  );
}
